import { render } from "./Skips.vue?vue&type=template&id=dcfa5478&scoped=true"
import script from "./Skips.vue?vue&type=script&lang=js"
export * from "./Skips.vue?vue&type=script&lang=js"

import "./Skips.vue?vue&type=style&index=0&id=dcfa5478&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcfa5478"]])

export default __exports__